import React, { useMemo } from 'react';

type CoursePdfViewerProps = {
  src: string;
};

/** 页内 PDF 预览：iframe 直链 OSS，禁右键，不提供下载按钮 */
export const CoursePdfViewer: React.FC<CoursePdfViewerProps> = ({ src }) => {
  const stableSrc = useMemo(() => src.trim(), [src]);
  return (
    <div className="course-resource-pdf-wrap" onContextMenu={(e) => e.preventDefault()}>
      <iframe
        title="PDF 阅读"
        className="course-resource-pdf-frame"
        src={stableSrc}
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
};
